import { ICrop, IFreeObject, ISize } from './interfaces';

export class ColorUtils {

    public static getHexColor(color: string): string {
        if (color.match(/^\s*#[0-9a-f][0-9a-f][0-9a-f][0-9a-f][0-9a-f][0-9a-f]\s*$/i)) {
            return color;
        }
        const regex = /^\s*rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/;
        const res = regex.exec(color);
        if (res) {
            return this.rgbToHex(parseInt(res[1], 10), parseInt(res[2], 10), parseInt(res[3], 10));
        } else {
            return '#000000';
        }
    }

    private static componentToHex(c: number): string {
        const hex = c.toString(16);
        return hex.length == 1 ? '0' + hex : hex;
    }

    private static rgbToHex(r: number, g: number, b: number): string {
        return '#' + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    }

}

export class CustomizerImagingUtils {

    public static getImageSizeFromMax(originalWidth: number, originalHeight: number, maxSize: number, outerWidth?: number, outerHeight?: number): ISize {
        let newWidth;
        let newHeight;
        if (outerWidth && outerHeight) {
            const zoomToFit = originalWidth / originalHeight > outerWidth / outerHeight ? outerWidth / originalWidth : outerHeight / originalHeight;
            newWidth = originalWidth * zoomToFit;
            newHeight = originalHeight * zoomToFit;
        } else {
            if (originalWidth > originalHeight) {
                newWidth = maxSize;
                newHeight = maxSize * (originalHeight / originalWidth);
            } else {
                newHeight = maxSize;
                newWidth = maxSize * (originalWidth / originalHeight);
            }
        }
        return {width: newWidth, height: newHeight};

    }

    public static isPhotoZone(freeObject: IFreeObject): boolean {
        return !(freeObject.isBackground || freeObject.isClipArt || freeObject.textEdits);
    }

    public static drawImageWithCrop(source: HTMLCanvasElement, crop: ICrop, sourceCrop: ICrop | null = null): string | null {
        if (sourceCrop == null) {
            sourceCrop = crop;
        }

        const canvas = document.createElement('canvas');
        canvas.width = crop.width;
        canvas.height = crop.height;
        const context = canvas.getContext('2d');
        if (context) {
            context.fillStyle = '#fff';
            context.fillRect(0, 0, canvas.width, canvas.height);
            context.drawImage(source, sourceCrop.x, sourceCrop.y, sourceCrop.width, sourceCrop.height, 0, 0, crop.width, crop.height);
            return canvas.toDataURL('image/jpeg');
        } else {
            return null;
        }
    }

    public static getImageFromUrl(url: string): Promise<HTMLImageElement> {
        return new Promise(async (resolve: (image: HTMLImageElement) => void, reject: (err: string) => void): Promise<void> => {
            const image = document.createElement('img') as HTMLImageElement;
            image.addEventListener('load', () => {
                resolve(image);
            });
            image.addEventListener('error', ev => {
                reject(ev.error);
            });
            const prefix = url.substring(0, 4);
            if (prefix !== 'http' && prefix !== 'data') {
                url = 'data:image/png;base64,' + url;
            }
            image.crossOrigin = 'anonymous';
            image.src = url;
        });
    }

    public static async addWhiteBackground(canvasString: HTMLCanvasElement|string): Promise<HTMLCanvasElement> {
        let imageOrCanvas:HTMLImageElement|HTMLCanvasElement;
        if (typeof canvasString === 'string') {
            imageOrCanvas = await this.getImageFromUrl(canvasString);
        } else {
            imageOrCanvas = canvasString;
        }

        const newCanvas = document.createElement('canvas');
        newCanvas.width = imageOrCanvas.width;
        newCanvas.height = imageOrCanvas.height;
        const context = newCanvas.getContext('2d');
        if (context) {
            context.fillStyle = '#fff';
            context.fillRect(0, 0, newCanvas.width, newCanvas.height);

            context.drawImage(imageOrCanvas, 0, 0);
        }
        return newCanvas;
    }
}


